import joint from 'jointjs';

const MAX_SCALE = 2;
const MIN_SCALE = 0.05;

const zoomState = {
  // we need to track the pointer position, to be used by keyboard shortcuts
  mousePointerX: null, 
  mousePointerY: null,

  // we need to capture a couple of context objects to be used in handlers
  paper: null, 
  $myholder: null,

  // A few attributes for the magnifying glass
  jointDiagramRect: null,
  lens: null,
  lensIsDisplayed: false,
};

function zoom(scaleDelta, event, paper, $myholder) {
  const scale = joint.V(paper.viewport).scale().sx;
  let newScale = scale + scaleDelta;
  // Limit Scale to min and max values
  newScale = Math.min(MAX_SCALE, Math.max(newScale, MIN_SCALE));

  paper.scale(newScale, newScale);
  paper.expandToFitContent();

  //Upate scroll after zoom to center to zoomed to area

  //ratio of the position of the point to zoom to (0 to 1) (0.5;0.5 is the middle of the diagram)
  let pointRatioX = 0.5;
  let pointRatioY = 0.5;
  if(event) {
    pointRatioX = (event.clientX - $myholder.offset().left) / $myholder.width();
    pointRatioY = (event.clientY - $myholder.offset().top) / $myholder.height();
  }
  const scaleRatio = newScale / scale;
  const newScrollTop = ($myholder.scrollTop() * scaleRatio) + ($myholder.height() * (scaleRatio - 1) * pointRatioY);
  const newScrollLeft = ($myholder.scrollLeft() * scaleRatio) + ($myholder.width() * (scaleRatio - 1) * pointRatioX);

  $myholder.scrollTop(newScrollTop);
  $myholder.scrollLeft(newScrollLeft);
}

// Zoom in on source or destination box of a link
export function zoomInOnSourceOrTargetBox(scale, cellview, paper, $myholder, type) {
  const $box = type == 'destination' ? cellview.targetView.$box : cellview.sourceView.$box;
  zoomInOnBoxWithAnimation(paper, $myholder, scale, $box);
}

export function zoomInOnBoxWithAnimation(paper, $myholder, scale, $box) {
  const newScale = Math.min(MAX_SCALE, Math.max(scale, MIN_SCALE));  // Limit scale to min and max values  
  const oldScale = paper.scale().sx;
  const newScrollLeft = $box.position().left/oldScale*newScale - (($myholder.width() - $box.width()) / 2);
  const newScrollTop = $box.position().top/oldScale*newScale - (($myholder.height() - $box.height()) / 2);

  const oldScrollTop = $myholder.scrollTop();
  const oldScrollLeft = $myholder.scrollLeft();
  
  scaleAndScrollStep(paper, $myholder, oldScale, newScale, oldScrollLeft, newScrollLeft, oldScrollTop, newScrollTop, 1,  Date.now());
}

function scaleAndScrollStep(paper, $myholder, oldScale, newScale, oldScrollLeft, newScrollLeft, oldScrollTop, newScrollTop, step, start) {
  const maxStep = 15;
  var elapsed = Date.now() - start;
  if (step <= maxStep && elapsed < 1000) {
    const currentScale = oldScale + (newScale - oldScale)*step/maxStep;
    const currentScrollLeft = oldScrollLeft + (newScrollLeft - oldScrollLeft)*step/maxStep;
    const currentScrollTop = oldScrollTop + (newScrollTop - oldScrollTop)*step/maxStep;
    setScaleAndScroll(paper, $myholder, currentScale, currentScrollLeft, currentScrollTop);
    requestAnimationFrame(() => scaleAndScrollStep(paper, $myholder, oldScale, newScale, oldScrollLeft, newScrollLeft, oldScrollTop, newScrollTop, step+1, start));
  } else if (elapsed >= 1000) {
    setScaleAndScroll(paper, $myholder, newScale, newScrollLeft, newScrollTop);
    requestAnimationFrame(() => scaleAndScrollStep(paper, $myholder, oldScale, newScale, oldScrollLeft, newScrollLeft, oldScrollTop, newScrollTop, maxStep+1, start));
  } else {
     paper.expandToFitContent();
  }
}

function setScaleAndScroll(paper, $myholder, scale, scrollLeft, scrollTop) {
  paper.scale(scale, scale);
  $myholder.scrollTop(scrollTop);
  $myholder.scrollLeft(scrollLeft);

}

// Scroll and zoom to els center
export function scrollToCenter($myholder, graph, paper) {
  let bbox = graph.getBBox(graph.getElements());
  // We calculate the theorical optimal margin, to see all the diagram at once with a small padding.
  let padding = 100;
  let wantedScale;
  let newScrollTop;
  let newScrollLeft;
  if (bbox) {
    let wantedScaleX = $myholder.width() / (bbox.width + padding);
    let wantedScaleY = $myholder.height() / (bbox.height + padding);
    // We want the same scale on both x and y axes.
    wantedScale = Math.min(wantedScaleY, wantedScaleX);  
  } else {
    // empty graph, let's default to 100% scale
    wantedScale = 1;
  }
  //Scale should be between 1 and MIN_SCALE (it is a zoom out)
  let scale = Math.max(MIN_SCALE, Math.min(wantedScale, 1));
  if (bbox) {
    // Calculate the coordinates of the top left corner point we want.
    let scrollOriginX = bbox.origin().x - ((($myholder.width() / scale) - bbox.width) / 2);
    let scrollOriginY = bbox.origin().y - ((($myholder.height() / scale) - bbox.height) / 2);
    newScrollTop = (scrollOriginY * scale);
    newScrollLeft = (scrollOriginX * scale);
  } else {
    // empty graph, use what would be calculated 
    // with the hardcoded question box at (x=5050,y=5050) in ScenarioV3.py
    newScrollLeft = 4675;
    newScrollTop = 4542; 
  }
  const currentScale = joint.V(paper.viewport).scale().sx;
  zoom(scale - currentScale, null, paper, $myholder);
  $myholder.scrollTop(newScrollTop);
  $myholder.scrollLeft(newScrollLeft);
}

function onMouseWheel(event, paper, $myholder) {
  event.preventDefault();
  const originalEvent = event.originalEvent;
  const delta = Math.max(-1, Math.min(1, (originalEvent.wheelDelta || -originalEvent.detail)));
  zoom(delta/10, originalEvent, paper, $myholder);
}

export function initZoomListeners(paper, $jointDiagramElement, $myholder) {
  zoomState.paper = paper;
  zoomState.$myholder = $myholder;
  zoomState.jointDiagram = $jointDiagramElement[0];

  paper.$el.on('mousewheel DOMMouseScroll', (e) => onMouseWheel(e, paper, $myholder));
  $jointDiagramElement.find('.zoomInBtn').click(function() {
    const scale = joint.V(paper.viewport).scale().sx;
    // zoom in in smaller steps while we are close to min scale
    const scaleDelta = scale >= 0.3 ? 0.1 : 0.05;
    zoom(scaleDelta, null, paper, $myholder);
  });
  $jointDiagramElement.find('.zoomOutBtn').click(function() {
    const scale = joint.V(paper.viewport).scale().sx;
    // zoom out in smaller steps as we get close to min scale
    const scaleDelta = scale > 0.3 ? -0.1 : -0.05;
    zoom(scaleDelta, null, paper, $myholder);
  });

  // hook mouse event to keep track of mouse position
  // document.addEventListener('mousemove', handleMouseMove);

  // hook keyboard shortcuts for max in and level 1 zoom
  // document.addEventListener('keydown', handleKeyDown);
}

export function removeZoomListeners() {
  // document.removeEventListener('mousemove', handleMouseMove);
  // document.removeEventListener('keydown', handleKeyDown);

}

function handleMouseMove(e) {
  // save pointer position
  zoomState.mousePointerX = e.clientX;
  zoomState.mousePointerY = e.clientY;

  if (zoomState.lensIsDisplayed) {
    updateLensPosition();
  }
}

function handleKeyDown(e) {
  const scale = joint.V(zoomState.paper.viewport).scale().sx;
  const pointerEvent = {
    clientX: zoomState.mousePointerX,
    clientY: zoomState.mousePointerY,
  };
  if (e.key === 'o') {
    // zoom in all the way to min scale
    hideLens();
    zoom(MIN_SCALE - scale, pointerEvent, zoomState.paper, zoomState.$myholder);
  }
  if (e.key === 'i') {
    // zoom to scale 0.8
    hideLens();
    zoom(0.8 - scale, pointerEvent, zoomState.paper, zoomState.$myholder);
  }
  if (e.key === 'l' && browserSupportsCSSElement()) {
    if (zoomState.lensIsDisplayed) {
      hideLens();
    } else {
      initLens();
    }
  }
}

function browserSupportsCSSElement() {
  return !!document.mozSetImageElement;
}

function initLens() {
  zoomState.lens = document.querySelector('#magnifying-glass');
  zoomState.jointDiagramRect = zoomState.jointDiagram.getBoundingClientRect();

  zoomState.lensIsDisplayed = true;
  zoomState.lens.style.display = 'block';
  const bgWidth = 10 * zoomState.jointDiagramRect.width;
  const bgHeight = 10 * zoomState.jointDiagramRect.height;
  zoomState.lens.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
  
  updateLensPosition();
}

function hideLens() {
  if (zoomState.lensIsDisplayed) {
    zoomState.lensIsDisplayed = false;
    zoomState.lens.style.display = 'none';
  }
}

function updateLensPosition() {
  const pointerOffsetX = zoomState.mousePointerX - zoomState.jointDiagramRect.x;
  const pointerOffsetY = zoomState.mousePointerY - zoomState.jointDiagramRect.y;
  const lensHalfWidth =  zoomState.lens.offsetWidth / 2;
  const lensHalfHeight = zoomState.lens.offsetHeight / 2;
  const lensLeft = pointerOffsetX - lensHalfWidth;
  const lensTop = pointerOffsetY - lensHalfHeight;
  zoomState.lens.style.left = `${lensLeft}px`;
  zoomState.lens.style.top = `${lensTop}px`;

  // The point (Mx, My) of the original joint diagram pointed at by the mouse pointer
  // is at the position (10*Mx, 10*My) on the zoomed-in (expanded) background.
  // For this point to be centered on the lens, the background needs to be shifted by
  // (10*Mx - w/2, 10*My - h/2) where w and h are the width and height of the lens
  zoomState.lens.style.backgroundPositionX = `${lensHalfWidth - 10 * pointerOffsetX}px`;
  zoomState.lens.style.backgroundPositionY = `${lensHalfHeight - 10 * pointerOffsetY}px`;
}